<template>
  <fragment v-if="isPodcaster()">
    <podcaster-podcast-manage />
  </fragment>
  <fragment v-else>
    <broadcaster-feed-create />
  </fragment>
</template>

<script>

import BroadcasterFeedCreate from "./Broadcaster/FeedCreate.vue";
import PodcasterPodcastManage from "./Podcaster/PodcastManage.vue";

export default {
  components: { BroadcasterFeedCreate, PodcasterPodcastManage },
};
</script>
